import BlankEtc from '@components/blank/BlankEtc';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import { css } from '@emotion/react';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import RecordRow from './components/RecordRow';
import TierCalcFilter from './components/TierCalcFilter';
import useTierHistory from './hooks/useTierHistory';

declare module '@stackflow/config' {
    interface Register {
        TierHistoryActivity: {};
    }
}

const TierHistoryActivity: ActivityComponentType<'TierHistoryActivity'> = () => {
    const { t } = useTranslation('tier');
    const {
        records, isBlank, fetchNextPage, isFetching, accumulationType,
    } = useTierHistory();
    return (
        <AppScreen>
            <CtaLayout header={
                <Header title={t('tierHistory.title')}
                    noShadow /> }>
                <TierCalcFilter/>
                {isBlank && (
                    <BlankEtc>
                        {t('tierHistory.blank')}
                    </BlankEtc>
                )}
                <Column fullWidth css={css`padding: 0 16px`}>
                    {records?.map((record) => (
                        <RecordRow record={record}
                            accumulationType={accumulationType}
                            key={record.recordId} />
                    ))}
                </Column>
                <InfinityScrollTrigger trigger={fetchNextPage}/>
                {isFetching && (<Loading size='small' />)}
            </CtaLayout>
        </AppScreen>
    );
};

export default TierHistoryActivity;
